import { LegacyIIQApi } from '../legacy-iiq-api';

export const getAipSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  () =>
    api.get('/aip-settings').then(({ data }) => data);

export const createAipSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (body: Record<string, any> = {}) =>
    api
      .post<any>('/aip-settings', body)
      .then(({ data, errors }) => ({ ...data, errors }));

export const saveAipSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (aipSettingsId: string, body: Record<string, any> = {}) =>
    api
      .patch<any>(`/aip-settings/${aipSettingsId}`, body)
      .then(({ data, errors }) => ({ ...data, errors }));
